import React from 'react';
import './MyEngagement.scss';
import { EngagementProcess } from '../../../slices/marketplace/timeline/models/engagement-process.model';
import { LevelsOfService } from '../../../slices/marketplace/timeline/models/enums/level-of-service.enum';
import BootstrapTable from '../../../components/react-bootstrap-table-next/react-bootstrap-table2';
import { LegalEntityTypeList } from '../../../slices/marketplace/timeline/models/enums/legal-enity-type';
import { stateToCodeMapper } from '../../../utils/constants';

interface MyEngagementProps {
    engagementProcess: EngagementProcess;
}

const MyEngagement = (props: MyEngagementProps) => {
    const formattedDate = new Date(
        props.engagementProcess.startDate
    ).toLocaleDateString('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
    });

    const columns = [
        {
            dataField: 'practiceName',
            text: 'Practice Name',
            sort: false,
            headerClasses: 'practice-name-header',
        },
        {
            dataField: 'entityName',
            text: 'Legal Entity Name',
            sort: false,
            headerClasses: 'practice-name-header',
        },
        {
            dataField: 'entityType',
            headerClasses: 'entity-type-header',
            text: 'Legal Entity Type',
            sort: false,
            formatter: (cellContent: number) => {
                return (
                    LegalEntityTypeList.find((item) => item.id === cellContent)
                        ?.abbreviation ?? 'NA'
                );
            },
        },
        {
            dataField: 'stateOfRegistration',
            headerClasses: 'state-of-registration-header',
            text: 'Legal Entity State of Registration',
            sort: false,
            formatter: (cellContent: string) => {
                return stateToCodeMapper(cellContent) ?? 'NA';
            },
        },
    ];

    const getPracticesTable = () => {
        return (
            <BootstrapTable
                bootstrap4
                remote
                keyField="id"
                data={props.engagementProcess.practices}
                columns={columns}
                noDataIndication="No data available"
            />
        );
    };

    return (
        <div className="my-engagement">
            <div className="body_inner_content">
                <div className="obpbq_row valuation_section">
                    <div className="sampledetail">
                        <h6>
                            Ownership Representative:{' '}
                            <span>{props.engagementProcess.userName}</span>
                        </h6>
                        <h6>
                            Level of Service:{' '}
                            <span>
                                {
                                    LevelsOfService.find(
                                        (l) =>
                                            l.id ===
                                            props.engagementProcess
                                                .levelOfService
                                    )?.name
                                }
                            </span>
                        </h6>
                        <h6>
                            Engagement Start Date: <span>{formattedDate}</span>
                        </h6>
                        <h6>Practices:</h6>
                        {getPracticesTable()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyEngagement;
